document.addEventListener("DOMContentLoaded", function () {
  let lastScrollY = window.pageYOffset;
  const header = document.querySelector("#header-wrapper");
  const threshold = header.offsetHeight + 50; // adjust as needed

  window.addEventListener("scroll", () => {
    const currentScrollY = window.pageYOffset;

    // Add background once scrolled past header height
    header.classList.toggle("scrolled", currentScrollY > threshold);

    if (currentScrollY > threshold) {
      if (currentScrollY > lastScrollY) {
        // Scrolling down - hide header
        header.classList.add("hidden");
      } else {
        // Scrolling up - show header
        header.classList.remove("hidden");
      }
    } else {
      // Top of page - always show
      header.classList.remove("hidden");
    }

    lastScrollY = currentScrollY;
  });
});
